exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.update[data-v-896deb02] {\r\n  transform: rotate(360deg);\r\n  -webkit-animation: rotating-data-v-896deb02 1s linear infinite;\r\n          animation: rotating-data-v-896deb02 1s linear infinite;\n}\n@-webkit-keyframes rotating-data-v-896deb02 {\n0% {\r\n    transform: rotate(0);\n}\n100% {\r\n    transform: rotate(360deg);\n}\n}\n@keyframes rotating-data-v-896deb02 {\n0% {\r\n    transform: rotate(0);\n}\n100% {\r\n    transform: rotate(360deg);\n}\n}\r\n", ""]);

// exports
